export default "__VITE_ASSET__eed2f4ae__"